import z from 'zod';

import { flatSchema, PRICE_CHANGE_TYPE } from 'modules/shaxmatka';

export const deleteSchema = z.object({ flats: z.number().array() });
export const initSchema = z.object({ entranceId: z.coerce.number() }).merge(flatSchema.pick({ col: true, floor: true }));
export const blockSchema = flatSchema.pick({ status: true });
export const updateSchema = flatSchema
  .pick({
    number: true,
    rooms: true,
    area: true,
    pricePerArea: true,
    priceRepaired: true,
    pricePerAreaRepaired: true,
    priceNotRepaired: true,
    prepaymentPercent: true,
    delay: true,
    repaired: true,
    apartment: true,
    terrace: true,
    discountID: true,
    gallery: true,
    fields: true,
    category: true,
    livingArea: true
  })
  .partial();

export const incrementSchema = z.object({
  flats: z.number().array(),
  priceChangeType: z.nativeEnum(PRICE_CHANGE_TYPE),
  value: z.coerce.number(),
  increase: z.coerce.boolean()
});

export const clearSchema = flatSchema.pick({
  price: true,
  rooms: true,
  area: true,
  pricePerArea: true,
  priceRepaired: true,
  pricePerAreaRepaired: true,
  priceNotRepaired: true,
  prepaymentPercent: true,
  delay: true,
  repaired: true,
  apartment: true,
  terrace: true,
  status: true,
  prepayment: true,
  gallery: true,
  discountID: true,
  fields: true,
  livingArea: true
});

export const pasteSchema = flatSchema.pick({
  rooms: true,
  area: true,
  repaired: true,
  apartment: true,
  terrace: true,
  status: true,
  prepaymentPercent: true,
  prepayment: true,
  delay: true,
  pricePerArea: true,
  pricePerAreaRepaired: true,
  priceRepaired: true,
  priceNotRepaired: true,
  gallery: true,
  discountID: true,
  fields: true,
  livingArea: true
});

export const numberingSchema = z.object({
  buildingId: z.number(),
  flats: z.array(z.number()),
  startNumber: z.coerce.number()
});

export type DeleteForm = z.infer<typeof deleteSchema>;
export type UpdateForm = z.infer<typeof updateSchema>;
export type IncrementForm = z.infer<typeof incrementSchema>;
export type InitForm = z.infer<typeof initSchema>;
export type BlockForm = z.infer<typeof blockSchema>;
export type ClearForm = z.infer<typeof clearSchema>;
export type PastForm = z.infer<typeof pasteSchema>;
export type NumberingForm = z.infer<typeof numberingSchema>;
